import { Route, Switch, useRouteMatch } from 'react-router-dom';
import List from './pages/list/List';

export default function SubGenreFeature() {
  const { path } = useRouteMatch();
  return (
    <div>
      <Switch>
        <Route exact path={path}>
          <List />
        </Route>
      </Switch>
    </div>
  );
}
